export const PICKER_TYPING_WITH_OPEN_POPPER_TOGGLE = 'EnableDatePickerTypingWithOpenCalendar';
